/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Label_GymInputs */

const en_contact_label_gym = /** @type {(inputs: Contact_Label_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gym`)
};

const pl_contact_label_gym = /** @type {(inputs: Contact_Label_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siłownia`)
};

/**
* | output |
* | --- |
* | "Gym" |
*
* @param {Contact_Label_GymInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_label_gym = /** @type {((inputs?: Contact_Label_GymInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Label_GymInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_label_gym(inputs)
	return en_contact_label_gym(inputs)
});